/**
 * Created by lu on 2018/5/4.
 */
var nb = require('../../../nb');
var input = require('../../../model/form/Input');

module.exports = nb.define({
    parent: nb.Model,
    mapping: {
        orderNum: input,
        productName:input,
        date1:nb.Model,
        date2:nb.Model
    },
    method: {
        init: function () {

        }
    }
});

// var select = require('../../../model/select/Select');
// orderTime:select,
//     selectState:select
// selectState:{
//     items:[{
//         name:'全部状态'
//     },{
//         name:'待付款'
//     },{
//         name:'已取消'
//     },{
//         name:'待发货'
//     },{
//         name:'待收货'
//     },{
//         name:'已完成'
//     },{
//         name:'待退款'
//     },{
//         name:'完成退款'
//     },{
//         name:'删除'
//     },{
//         name:'申请退货'
//     },{
//         name:'拒绝退货'
//     },{
//         name:'待退货'
//     },{
//         name:'已退货'
//     },{
//         name:'下单失败'
//     },{
//         name:'已失效'
//     }]
// },
// orderTime:{
//     items:[{
//         name:'近三个月'
//     },{
//         name:'近六个月'
//     },{
//         name:'近一年'
//     }]
// }


//////////////////
// WEBPACK FOOTER
// ../src/js/page/order/model/OrderScreen.js
// module id = 679
// module chunks = 3